// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__1wmT_","footer":"Form_footer__3qXNk"};